import { mockData1 } from "./mockData"
import { simpleDeepClone } from "@/utils"

export class multiFilter {
  constructor(difference) {
    this.isSystemComponent = true
    this.isIndependenceComponent = true
    this.isDefaultComponent = true
    this.categoryNames = []
    this.showCategoryNames = false
    this.width = 600
    this.height = 550
    this.top = 20
    this.left = 20
    this.innerElement = "cxMultiFilter"
    this.color = "#2E2E30"
    this.textIsThemeColor = false
    this.background = []
    this.bgColor = "rgb(255, 255, 255)"
    this.imgSrc = ""
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.opacity = 1
    this.borderTypeFlag = 2 //圆角的类型 分为1四个角可以单独设置 2四个角一致
    this.borderRadius = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderColor = "rgba(255, 255, 255, 0)"
    this.borderWidth = 0
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.paddingTypeFlag = 1
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0

    this.fontFamily = "sans-serif"
    this.fontSize = 13
    this.fontWeight = 400
    this.fontStyle = "normal"
    this.textDecoration = "none"
    this.lineHeight = 20
    this.letterSpacing = 0
    this.writingMode = "horizontal-tb"
    this.textAlign = "center"
    this.textIsThemeColor = false
    this.lineMargin = 8
    this.columnMargin = 8

    this.moreFilter = true
    this.groupMargin = 16
    this.contentHasLimit = true
    this.textLimitLines = 2

    this.defaultBorderTypeFlag = 2 //圆角的类型 分为1四个角可以单独设置 2四个角一致
    this.defaultBorderRadius = 4
    this.defaultBorderTopLeftRadius = 4
    this.defaultBorderTopRightRadius = 4
    this.defaultBorderBottomLeftRadius = 4
    this.defaultBorderBottomRightRadius = 4
    this.defaultBorderWidth = 0
    this.defaultBorderStyle = "solid" // solid, dashed, dotted
    this.defaultBorderColor = "#E9E9E9"
    this.defaultBorderIsThemeColor = false
    this.defaultPaddingTypeFlag = 2
    this.defaultPadding = 2
    this.defaultPaddingTop = 2
    this.defaultPaddingRight = 6
    this.defaultPaddingBottom = 2
    this.defaultPaddingLeft = 6
    this.defaultBackground = []
    this.defaultBgColorIsThemeColor = false
    this.defaultBgColor = "rgb(255, 255, 255)"
    this.defaultBoxShadowColor = []
    this.defaultBoxShadowH = []
    this.defaultBoxShadowV = []
    this.defaultBoxShadowBlur = []
    this.defaultBoxShadowSpread = []

    this.titleFontFamily = "sans-serif"
    this.titleFontSize = 13
    this.titleFontWeight = 400
    this.titleFontStyle = "normal"
    this.titleTextDecoration = "none"
    this.titleLineHeight = 20
    this.titleLetterSpacing = 0
    this.titleTextIsThemeColor = false
    this.titleColor = "#7B7B7D"
    this.titleBackground = []
    this.titleBgColorIsThemeColor = false
    this.titleBgColor = "rgb(255, 255, 255)"
    this.titleBoxShadowColor = []
    this.titleBoxShadowH = []
    this.titleBoxShadowV = []
    this.titleBoxShadowBlur = []
    this.titleBoxShadowSpread = []
    this.titlePaddingTypeFlag = 1
    this.titlePadding = 2
    this.titlePaddingTop = 2
    this.titlePaddingRight = 6
    this.titlePaddingBottom = 2
    this.titlePaddingLeft = 6
    this.titleBorderTypeFlag = 2 //圆角的类型 分为1四个角可以单独设置 2四个角一致
    this.titleBorderRadius = 0
    this.titleBorderTopLeftRadius = 0
    this.titleBorderTopRightRadius = 0
    this.titleBorderBottomLeftRadius = 0
    this.titleBorderBottomRightRadius = 0
    this.titleBorderColor = "#E9E9E9"
    this.titleBorderWidth = 0
    this.titleBorderStyle = "solid" // solid, dashed, dotted
    this.titleBorderIsThemeColor = false
    this.titleContentHasLimit = true
    this.titleTextLimitLines = 2
    this.titleWidth = 56

    this.hoverFontFamily = "sans-serif"
    this.hoverFontSize = 14
    this.hoverFontWeight = 400
    this.hoverFontStyle = "normal"
    this.hoverTextDecoration = "none"
    this.hoverLineHeight = 20
    this.hoverLetterSpacing = 0
    this.hoverColorIsThemeColor = false
    this.hoverColor = "rgba(0,0,0,0.6)"
    this.hoverBorderTypeFlag = 2
    this.hoverBorderRadius = 4
    this.hoverBorderTopLeftRadius = 4
    this.hoverBorderTopRightRadius = 4
    this.hoverBorderBottomRightRadius = 4
    this.hoverBorderBottomLeftRadius = 4
    this.hoverBgColorIsThemeColor = false
    this.hoverBgColor = "rgba(43, 103, 255, 0.16)"
    this.hoverBorderIsThemeColor = false
    this.hoverBorderColor = "rgba(43, 103, 255, 0.16)"
    this.hoverBorderStyle = "solid" // solid, dashed, dotted
    this.hoverBorderWidth = 0
    this.hoverBackground = []
    this.hoverBoxShadowColor = []
    this.hoverBoxShadowH = []
    this.hoverBoxShadowV = []
    this.hoverBoxShadowBlur = []
    this.hoverBoxShadowSpread = []

    this.activeFontFamily = "sans-serif"
    this.activeFontSize = 13
    this.activeFontWeight = 400
    this.activeFontStyle = "normal"
    this.activeTextDecoration = "none"
    this.activeLineHeight = 20
    this.activeLetterSpacing = 0
    this.activeColorIsThemeColor = false
    this.activeColor = "rgba(255,255,255,1)"
    this.activeBorderTypeFlag = 2
    this.activeBorderRadius = 20
    this.activeBorderTopLeftRadius = 20
    this.activeBorderTopRightRadius = 20
    this.activeBorderBottomRightRadius = 20
    this.activeBorderBottomLeftRadius = 20
    this.activeBgColorIsThemeColor = true
    this.activeBgColor = "rgba(0,0,0,0)"
    this.activeBorderIsThemeColor = false
    this.activeBorderColor = "#3D82F2"
    this.activeBorderStyle = "solid" // solid, dashed, dotted
    this.activeBorderWidth = 1
    this.activeBackground = []
    this.activeBoxShadowColor = []
    this.activeBoxShadowH = []
    this.activeBoxShadowV = []
    this.activeBoxShadowBlur = []
    this.activeBoxShadowSpread = []

    this.noCacheComponent = true
    this.restDataUrl = "" // 外接数据源地址
    this.selectOptions = simpleDeepClone(mockData1)
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
